import React, { useEffect, useRef, useState } from 'react'
import { useSelector } from 'react-redux'

// LAYOUT COMPONENTS
import Navbar from '../components/Layout/Navbar'
import FullPageLoader from '../components/Layout/FullPageLoader'
import Empty from '../components/Layout/Empty'

// COMPONENTS
import FilterBar from '../components/topSales/FilterBar'
import TopSalesCommissionListing from '../components/topSales/TopSalesCommissionListing'
import TopSalesCommissionTable from '../components/topSales/TopSalesCommissionTable'
import SalesDateListingTable from '../components/topSales/SalesDateListingTable'
import PVDateListingTable from '../components/topSales/PVDateListingTable'

// DATA
import agentComponent from '../businesses/agent'


const TopSalesPage = () => {
  const agentID = useSelector(state => state.viewFromAgentId);
  const tableContainer = useRef(null)

  const [loading, setLoading] = useState(false)
  const [isFetching, setIsFetching] = useState(false)
  const [filterData, setFilterData] = useState(null)
  const [listedBy, setListedBy] = useState('Branch')

  const [entities, setEntities] = useState(null)
  const [selectedEntity, setSelectedEntity] = useState(null)
  const [selectedAgentSales, setSelectedAgentSales] = useState(null)
  const [selectedAgentPV, setSelectedAgentPV] = useState(null)


  const handleFilter = (data) => {
    const filterData = { ...data }
    filterData.StartDate = data.StartDate.toISOString()
    filterData.EndDate = data.EndDate.toISOString()
    filterData.PVStartDate = data.PVStartDate.toISOString()
    filterData.PVEndDate = data.PVEndDate.toISOString()

    setListedBy(filterData.LiveListBy)
    setEntities(null)
    setSelectedEntity(null)
    setSelectedAgentSales(null)
    setSelectedAgentPV(null)

    // RUN THE FILTERING WITH THE filterData
    setFilterData(filterData)
    setIsFetching(!isFetching)
  }

  const selectEntity = (entity) => {
    setSelectedEntity(null)
    setSelectedAgentSales(null)
    setSelectedAgentPV(null)

    // SETTIMEOUT SO CHANGES WILL REFLECT
    setTimeout(() => {
      if (entity) {
        setSelectedEntity(entity)
      }
    }, 1);
  }

  const selectAgent = (agent) => {
    const agentID = agent.CommissionPayToUserObjectID
    setSelectedAgentSales(null)
    setSelectedAgentPV(null)

    if (agentID) {
      (async () => {
        setLoading(true)
        const agentCompletedSalesListingByDate = await agentComponent.getAgentCompletedSalesListingByDate(agentID, filterData)
        if (agentCompletedSalesListingByDate) {
          setSelectedAgentSales(agentCompletedSalesListingByDate?.commissionCollection)
          setSelectedAgentPV(agentCompletedSalesListingByDate?.payoutCollection)
          setLoading(false)
        } else {
          setLoading(false)
        }
      })()
    }
  }


  useEffect(() => {
    if (agentID && filterData) {
      (async () => {
        setLoading(true)
        const top10CompletedSalesByDate = await agentComponent.getTop10CompletedSalesByDate(agentID, filterData)

        if (top10CompletedSalesByDate.length > 0) {
          setEntities(top10CompletedSalesByDate)
          setLoading(false)
        } else {
          setLoading(false)
        }
      })()
    }
  }, [isFetching])

  useEffect(() => {
    if (selectedAgentSales || selectedAgentPV) {
      tableContainer.current.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      })
    }
  }, [selectedAgentSales, selectedAgentPV])


  return (
    <div className='layout topsales'>
      <Navbar title='Top 10 Completed Sales Commission' />
      <FilterBar onHandleFilter={ handleFilter } />

      <div className='content-wrapper'>
        <div className='content'>
          <FullPageLoader loading={ loading } />

          {
            entities ?
            <>
              <div className='left'>
                {
                  entities &&
                  <TopSalesCommissionListing
                    listedBy={ listedBy }
                    entities={ entities }
                    handleClick={ selectEntity }
                  />
                }
              </div>

              <div className='right'>
                <div className='tables-wrapper'>
                  <div className='scrollable'>
                    <div className='flex flex-col gap-3'>
                      {
                        selectedEntity &&
                        <TopSalesCommissionTable
                          selectedEntity={ selectedEntity }
                          handleClick={ selectAgent }
                        />
                      }

                      <div ref={ tableContainer } className='flex flex-col gap-3'>
                        {
                          selectedAgentSales &&
                          <SalesDateListingTable
                            selectedEntity={ selectedEntity }
                            selectedAgent={ selectedAgentSales }
                            filterData={ filterData }
                          />
                        }
                        {
                          selectedAgentPV &&
                          <PVDateListingTable
                            selectedEntity={ selectedEntity }
                            selectedAgent={ selectedAgentPV }
                            filterData={ filterData }
                          />
                        }
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </> :
            <>
              <Empty />
            </>
          }
        </div>
      </div>
    </div>
  )
}

export default TopSalesPage